import { render, staticRenderFns } from "./NshopViewerStatistics.vue?vue&type=template&id=b480b7d8&scoped=true&"
import script from "./NshopViewerStatistics.vue?vue&type=script&lang=js&"
export * from "./NshopViewerStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b480b7d8",
  null
  
)

export default component.exports